<script setup>
import { useI18n } from 'vue-i18n';
import RealEstateCommissionPaymentDialog from './RealEstateCommissionPaymentDialog.vue';
import RealEstateCommissionSendDialog from './RealEstateCommissionSendDialog.vue';
import RealEstateCommissionSheetFooter from './RealEstateCommissionSheetFooter.vue';

defineProps({
  activeGroupIndex: { type: Number, default: 0 },
  canDownload: { type: Boolean, default: false },
  canSend: { type: Boolean, default: false },
  downloading: { type: Boolean, default: false },
  isLastGroup: { type: Boolean, default: false },
  paymentRecipientName: { type: String, default: '' },
  paymentRow: { type: Object, default: null },
  paymentTarget: { type: Object, default: null },
  preview: { type: Boolean, default: false },
  sendDialogVisible: { type: Boolean, default: false },
  state: { type: Object, required: true },
});

const emit = defineEmits([
  'close-payment',
  'close-send',
  'confirm-send',
  'download',
  'next',
  'preview',
  'previous',
  'save-payment',
  'send',
]);
const { t } = useI18n();
</script>

<template>
  <RealEstateCommissionSheetFooter
    v-if="state.installment.value"
    :active-group-index="activeGroupIndex"
    :can-download="canDownload"
    :can-send="canSend"
    :downloading="downloading"
    :is-last-group="isLastGroup"
    :preview="preview"
    :saving="state.saving.value"
    :sent="state.installment.value.enviada"
    :sent-at="state.installment.value.ultima_data_envio || ''"
    @download="emit('download')"
    @next="emit('next')"
    @preview="emit('preview')"
    @previous="emit('previous')"
    @send="emit('send')"
  />
  <RealEstateCommissionPaymentDialog
    :banks="state.catalog.value.bancos || []"
    :pix-keys="state.catalog.value.chaves_pix || []"
    :recipient-name="paymentRecipientName"
    :row="paymentRow"
    :show="Boolean(paymentTarget)"
    :title="t('REAL_ESTATE_COMMISSION_INSTALLMENT.PAYMENT.TITLE')"
    @close="emit('close-payment')"
    @save="emit('save-payment', $event)"
  />
  <RealEstateCommissionSendDialog
    :installment="state.installment.value"
    :loading="state.sending.value"
    :show="sendDialogVisible"
    @close="emit('close-send')"
    @confirm="emit('confirm-send')"
  />
</template>
